'use client';

import { useEffect } from 'react';

const DEFAULT_BUTTON_DISPLAY_VAR = '--medallia-side-button-display';

export function useMedalliaDefaultButton() {
    useEffect(() => {
        const documentStyles = document.documentElement.style;
        documentStyles.setProperty(DEFAULT_BUTTON_DISPLAY_VAR, 'flex', 'important');

        return () => {
            documentStyles.removeProperty(DEFAULT_BUTTON_DISPLAY_VAR);
        };
    }, []);
}
